<template>
  <div v-loading="pageLoading">
    <div>
      <el-form 
               style="margin: auto; width: 1000px"
               :model="form"
              :rules="rules" 
               ref="form"
               >
        <el-form-item label="賬號"
                      :label-width="formLabelWidth"
                      prop="account"
                      :rules="[
                          { required: true, message: '賬號不能为空' },
                        ]"

                      >
          <el-input v-model="form.account"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="密碼"
                      :label-width="formLabelWidth">
          <el-input v-model="form.pwd"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="分公司"
                      :label-width="formLabelWidth">
          <el-select v-model="form.region"
                     placeholder=""
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in $store.state.commonData.regionList"
                       :key="item.id"
                       :label="item.regionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部門/物業"
                      :label-width="formLabelWidth">
          <el-select v-model="form.filiale"
                     placeholder=""
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in $store.state.commonData.branchList"
                       :key="item.id"
                       :label="item.branchName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用戶組別"
                      class="special_color"
                      :label-width="formLabelWidth">
          <el-select v-model="form.department"
                     placeholder=""
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in $store.state.commonData.departmentList"
                       :key="item.id"
                       :label="item.departmentName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="職位"
                      :label-width="formLabelWidth"
                      class="special_color">
          <el-select v-model="form.position"
                     placeholder=""
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in $store.state.commonData.positionList"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名"
                      :label-width="formLabelWidth">
          <el-select v-model="form.id"
                     placeholder=""
                     style="width: 80%"
                     disabled>
            <el-option :label="form.name"
                       :value="form.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可以發佈資訊">
          <el-radio-group v-model="form.ispublish">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否接收消息通知"
                      v-show="isPersonnel">
          <el-radio-group v-model="isMssage">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$router.back(-1)">取 消</el-button>
        <el-button type="primary"
                   @click="editUser">確 定</el-button>
      </div>
      <el-button class="back"
                 @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,

      form: {
        account: "",
        pwd: "",
        region: "",
        name: "",
        filiale: "",
        department: "",
        position: "",
        id: "",
        ispublish: "",
      },
      region: [],
      filiale: [],
      department: [],
      position: [],
      formLabelWidth: "130px",
      userId: "",
      password: "",
      isPersonnel: false,
      isMssage: "0",
    };
  },
  mounted () {
    $("#pageHead").text("修改APP用戶");
    
    // 分公司
    this.$store.dispatch('commonData/getBranchList')
    // 部門
    this.$store.dispatch('commonData/getDepartmentList')
    // 地區
    this.$store.dispatch('commonData/getRegionList')
    //  職位
    this.$store.dispatch('commonData/getPositionList')

    this.pageLoading = true
    this.axios({
      url: "/manage/getTerUser",
      params: {
        id: that.userId,
      },
    }).then((res) => {
      var msg = res.result[0]
      var form = that.form;
      form.pwd = msg.password;
      that.password = msg.password;
      form.ispublish = msg.publishedArticles;
      form.name = msg.comUserName;
      form.id = msg.comUserId;
      form.region = msg.manRegionId;
      form.filiale = msg.manBranchId;
      form.department = msg.manDepartmentId;
      form.position = msg.manPositionId;
      this.isMssage = msg.isMessage ? msg.isMessage.toString : "0"
      that.department.forEach((item) => {
        if (item.id == msg.manDepartmentId && item.departmentName == "人事部") {
          that.isPersonnel = true;
        }
      });

         var accountIF = /^[0-9]+$/.test(msg.account);
         //console.log("*****************************"+accountIF);
          if(accountIF){
            form.account = parseInt(msg.account);
          }else{
            form.account = msg.account;
          } 
      this.pageLoading = false
    });
  },
  methods: {
    editUser () {
      var form = that.form;
      var msg = {
        account: form.account,
        publishedArticles: form.ispublish,
        comUserId: form.id,
        id: that.userId,
      };


      if (that.password != form.pwd) {
        // 判断密码是否改变
        if (form.pwd.length < 0) {
          that.$message({
            type: "warning",
            message: "請填寫密碼!",
          });
          return;
        }
        msg["password"] = form.pwd;
      }
      
      for (let item in msg) {
        if (msg[item] === "") {
          console.log(msg[item]);
          that.$message({
            type: "warning",
            message: "請將信息填寫完整!",
          });
          return;
        }
       
      }

      // if (!(/^[0-9]*$/.test(form.account))) {
      //   this.$message({
      //     type: 'warning',
      //     message: '職員編號只能使用數字'
      //   })
      //   return
      // }

      if (this.isPersonnel) {
        msg["isMssage"] = this.isMssage;
      }
      this.pageLoading = true
      this.axios({
        url: "/manage/updateTerUser",
        params: msg,
        method: "post",
      }).then(res => {
        if (res) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          this.pageLoading = false
        }
      });
    },
  },
  created () {
    that = this;
    this.userId = sessionStorage.getItem("userId");
  },
};
</script>

<style scoped>
.back {
  position: absolute;
  top: 90px;
  right: 45px;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}
.el-form-item {
  width: 500px;
  display: inline-block;
}
</style>
